<!-- VapiEmbed.vue -->
<template>
  <div>
    <h4 class="mb-3">Bem-vindo(a)!</h4>
    <p>Esta é uma pré-entrevista rápida para coletar algumas informações iniciais de forma simples e prática. Você vai conversar com um assistente que utiliza reconhecimento de voz para conduzir o bate-papo.</p>
    <ul>
      <li>Serão aproximadamente <strong>{{ total_questions }}</strong> perguntas.</li>
      <li>A duração estimada é de <strong>{{ estimed_time_minutes }} minutos</strong>.</li>
    </ul>

    <hr class="my-4" />

    <h5>🤔 É uma entrevista por IA?</h5>
    <p>Não. As perguntas foram elaboradas por um recrutador humano, e o assistente está aqui apenas para facilitar a conversa, registrar suas respostas e tornar o processo mais ágil.</p>
    <p>A análise e a decisão final também ficam totalmente a cargo de um recrutador humano.</p>

    <hr class="my-4" />

    <h5>🎧 Teste rápido de som</h5>
    <ul>
      <li>Permita o acesso ao <strong>microfone</strong> quando solicitado.</li>
      <li>O assistente vai perguntar se você está ouvindo bem.</li>
      <li>Para começar, basta responder: “Estou escutando bem” ou “Podemos começar”.</li>
    </ul>

    <div class="alert alert-warning mt-4" role="alert">
      <h5>Atenção:</h5>
      <strong>Procure um lugar totalmente silencioso</strong>  para fazer o bate-papo, evitando ruídos de fundo que possam atrapalhar o reconhecimento de voz.
    </div>

    <div class="mt-4">
      <button
        v-if="!loading"
        class="btn btn-primary"
        @click="start">Ok, entendi!</button>
      <button
        v-if="loading"
        class="btn btn-secondary"
        disabled>Carregando...</button>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/AxiosInstance'

export default {
  name: 'IntervoiceStart',
  components: {},
  props: {
    token: {
      type: String,
      required: true
    },
    estimed_time_minutes: {
      type: Number,
      required: false,
      default: null
    },
    total_questions: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  watch: {
  },
  methods: {
    async start () {
      this.loading = true
      try {
        const response = await axios.get(`/guest/intervoice/${this.token}`)
        this.$emit('start', response.data)
      } catch (error) {
        console.error('IntervoiceTest.vue created error:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
</style>
